module.exports = __webpack_public_path__ + "media/recipes/28-f77fa6f4.png";